import React, { Fragment } from "react";

import { TableTabs } from "../../../shared/components";
import {
  MobileSort,
  TableSearch,
} from "../../../../../../components/table/components";
import { Mobile } from "../../../../../../hocs/Responsive";
import { BlockedDeviceLimitReached } from "../blockedDeviceLimitReached";

export const BlockedDevicesTableHeader = () => {
  return (
    <Fragment>
      <TableTabs />
      <TableSearch />

      <Mobile>
        <MobileSort />
      </Mobile>

      <BlockedDeviceLimitReached />
    </Fragment>
  );
};
